import React from "react";
import { Icon } from "@vds/icons";
import { Button } from "@vds/buttons";
import { useNavigate } from "react-router-dom";
import { Body, Title } from "@vds/typography";

const ErrorPage = () => {
  let navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <div
        style={{
          padding: "32px",
          background: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            alignItems: "center",
          }}
        >
          <Icon
            name="error"
            style={{ width: "50px", height: "50px", marginBottom: "20px" }}
            color="#FF8027"
            size={60}
          />
          <Title size="large">This page doesn’t exist.</Title>
          <Body size="large">
            Please check the URL or return to the dashboard.
          </Body>
          <Button onClick={handleGoToDashboard}>Go to dashboard</Button>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
